import { AfterViewInit, Component, HostBinding, OnDestroy, OnInit, ViewEncapsulation, ViewChildren, QueryList, ChangeDetectorRef, ViewChild, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { MatTooltip } from '@angular/material/tooltip';

import { Client } from 'src/providers/client/client';

import packageJson from 'package.json';
import { Communication } from 'src/providers/communication/communication';
import { Dashboard } from 'src/providers/dashboard/dashboard';
import { AuthModalService } from 'src/shared/services/auth-modal.service';
import { GuestAccountService } from 'src/shared/services/guest-account.service';
import { DemoBlockService } from 'src/shared/services/demo-block.service';
import { RentalModesService } from 'src/shared/services/rental-modes.service';
import { AddressesQueriesService } from 'src/shared/services/addresses-queries.service';
import { Auth } from 'src/providers/auth/auth';

import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { Me } from 'src/providers/me/me';
import { WindowService } from 'src/shared/providers/window.service';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { AgentsProvider } from 'src/providers/agents/agents';

import { ContactInfoPage } from 'src/pages/more/contact-info/contact-info';
import { DemoPage } from 'src/pages/demo/demo';
import { SubscriptionsPage } from 'src/pages/subscription/subscription';
import { ChangeSubscriptionPage } from 'src/pages/subscription/change-subscription/change-subscription';
import { ConciergePage } from 'src/pages/concierge/concierge';
import { notificationCenterDropDownMenu, NotificationCenterPage } from 'src/pages/notification-center/notification-center';
import { HeaderProvider } from 'src/providers/header/header';
import { NotificationsQueriesService } from 'src/shared/services/notifications-queries.service';

import { Util } from 'src/shared/util/util';

import { agentItem, tasksItem, automationsItem, moreItem, desktopNavItems, automationsSectionItems, billsItem, financeItem, inventoryItem, employerItems, employerItemsMock, integrationSectionItems, propertiesItem, marketingItem, complianceItem, eSignItem, guidebookItem, upsellsItem, prosItem, operationsSection, operationsOverviewItem, operationsAssetsItem, operationsAccessItem, operationsUpgradesItem, noiseMonitoringItem, insuranceItem, financeSection, financeSectionItems, marketingSection, marketingSectionItems } from 'src/shared/components/desktop-nav/desktop-nav-items';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Menu } from 'src/providers/menu/menu';
import { Events } from 'src/providers/events/events';
import { CurrentAddress } from 'src/providers/addresses/current-address';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { OnboardingProvider } from 'src/providers/onboarding/onboarding.provider';
import { propertyDashboardPath } from 'src/providers/guard/rental-routes.guard';
import { ThemeService } from 'src/shared/services/theme.service';
import { TranslationService } from 'src/tidy-ui-components/providers/translation.service';
import * as confetti from 'canvas-confetti';
import { spookyConfetti } from 'src/shared/util/halloween';

@Component({
    selector: 'app-desktop-nav',
    templateUrl: './desktop-nav.component.html',
    styleUrls: ['./desktop-nav.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DesktopNavComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChildren(MatTooltip) tooltips: QueryList<MatTooltip>;
  @ViewChild('userIconRef') userIconRef: ElementRef;
  @ViewChild('userDropdownRef') userDropdownRef: ElementRef;

  // One-shot entrance: the profile header and nav items cascade in when the
  // nav is first created (app start / login). The class is removed once the
  // cascade finishes so menu updates and collapse toggles never re-animate.
  @HostBinding('class.page-entrance') entranceActive = false;

  private tooltipDisabled = false;
  accType: string;
  automationOptions: any;
  accountName: string;
  currentItem: any;
  agentsMenuExpanded = true;
  operationsMenuExpanded = false;
  financeMenuExpanded = false;
  marketingMenuExpanded = false;
  hasFinanceSection = false;
  hasMarketingSection = false;
  helpMenuExpanded = false;
  menuRenderVisible = true;
  initials = '';
  isEmployerAccount = false;
  showUserDropdown = false;
  userName: string;
  userRole: string | null;
  menuItems;
  operationsItems: any[] = [];
  rootItems: any[] = [];
  agentNavItem: any = null;
  scheduleNavItem: any = null;
  isOverviewActive = false;
  isPropertiesActive = false;
  isScheduleActive = false;
  readonly operationsSection = operationsSection;
  readonly financeSection = financeSection;
  readonly marketingSection = marketingSection;
  // Finance subitems no longer include Overview — it's promoted above Chat as
  // its own root-level item.
  financeItems = financeSectionItems
    .filter(item => item.tab !== 'overview')
    .map(item => ({ ...item, _isCurrentItem: false }));
  marketingItems = marketingSectionItems.map(item => ({ ...item, _isCurrentItem: false }));

  // ---- Long-term rental gating (Account Settings toggle) ----
  // Sections that only exist for long-term rentals. With the toggle off they're
  // dropped from the nav entirely; the routes still resolve if deep-linked.
  private static readonly LONG_TERM_FINANCE_TABS = ['deposits', 'rent-collection'];
  private static readonly LONG_TERM_MARKETING_TABS = ['leasing'];
  private static readonly LONG_TERM_TARGETS = ['/e-sign'];
  longTermRentals = true;
  // The unfiltered menu as built by updateMenuData, kept so the mode toggle can
  // re-filter without rebuilding the whole menu from scratch.
  private rawMenuItems: any[] | null = null;
  menuAddresses: any;
  currentAddress: number;
  dashboardOpts: any;
  loading: boolean;
  filteredAddresses: any;
  form: UntypedFormGroup
  integrationOptions: any;
  addAddressSubs: Subscription;
  addAddressRoute: boolean;
  addReportRoute: boolean;
  showSecondaryMenu = false;
  isAllAddressesSelected: boolean;
  logo: string;
  isMenuCollapsed = false; // Default to expanded (showing text)
  showMenuText = true; // Controls text visibility after animation
  backgroundColor: string;
  private textDisplayTimeout: any; // Track timeout for clearing
  subscription: any;
  hasNegativeBalance = false;
  isAccountSuspended = false;
  showOnboarding = false;
  completedGoals = 0;
  totalGoals = 0;
  isAuthModalOpen = false;
  isGuestAccount = false;
  fadeInSignIn = false;
  oldCompletedGoals = 0;
  automatedPercentage = 0;
  oldAutomatedPercentage = 0;
  showGlowAnimation = false;
  isInitialLoad = false;
  agentSettings: any;
  appVersion = packageJson.version;
  showAppVersion = false;
  isRentalClient = false;
  private longPressTimeout: any;
  private agentSettingsSubscription: Subscription;
  private authModalSubscription: Subscription;
  private dashboardUpdate$ = new Subject<boolean>();
  private dashboardUpdateSubscription: Subscription;

  constructor(
    private addressesQueries: AddressesQueriesService,
    private agentsProvider: AgentsProvider,
    public authModalService: AuthModalService,
    private changeDetector: ChangeDetectorRef,
    private client: Client,
    private communication: Communication,
    private currentAddressService: CurrentAddress,
    private dashboard: Dashboard,
    private events: Events,
    private formBuilder: UntypedFormBuilder,
    private guestAccountService: GuestAccountService,
    public headerProvider: HeaderProvider,
    private me: Me,
    public menu: Menu,
    private navCtrl: CustomNavController,
    private notificationsQueries: NotificationsQueriesService,
    public onboardingProvider: OnboardingProvider,
    private platform: Platform,
    private renderer: Renderer2,
    private rightSidePanelService: RightSidePanelService,
    public router: Router,
    private storage: TidyStorage,
    private util: Util,
    private windowService: WindowService,
    private auth: Auth,
    public themeService: ThemeService,
    private demoBlock: DemoBlockService,
    private rentalModes: RentalModesService,
    private translationService: TranslationService
  ) {
    this.form = this.formBuilder.group({
      search: ''
    });
    // Account Settings (My Account) gates whole long-term sections; re-filter the
    // nav in place whenever the toggle flips so it updates without a reload.
    this.rentalModes.modes$
      .pipe(takeUntilDestroyed())
      .subscribe((modes) => {
        this.longTermRentals = modes.longTerm;
        this.applyRentalModes();
        this.changeDetector.markForCheck();
      });
    // Nav labels render through the pure `translate` pipe, which won't re-run
    // when the language changes because the label strings stay the same. Tear
    // the menu subtree down and rebuild it in the same synchronous tick so the
    // pipes re-evaluate against the new language — no reload, no visible flash.
    this.translationService.languageChange
      .pipe(takeUntilDestroyed())
      .subscribe(() => {
        this.menuRenderVisible = false;
        this.changeDetector.detectChanges();
        this.menuRenderVisible = true;
        this.changeDetector.detectChanges();
      });
    this.events.subscribe('updateMenu', () => this.updateMenuData());
    this.events.subscribe('add:address', async () => {
      await this.addressesQueries.refetch();
      await this.updateMenuData();
    });
    this.events.subscribe('address:changed', () => this.updateMenuData());
    this.events.subscribe('auth:complete', () => this.onAuthComplete());
    this.events.subscribe('auth:type-selected', () => this.onTypeSelected());
    this.events.subscribe('update:addressId', (addressId) => {
      this.currentAddress = parseInt(addressId, 10);
      this.updateMenuData();
    });
    this.events.subscribe('toggle:nav:collapse', () => this.toggleNavCollapse())
    this.dashboard.newReportAdded.pipe().subscribe(value => {
      this.menu.dashboardSection = `/reports/${value.id}`;
      this.updateDashboardSection(true);
    });

    this.addAddressSubs = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.updateMenuData()
        this.addAddressRoute = event.url === '/add-property';
        this.addReportRoute = event.url === '/reports/add-report';
        // Ensure menu items are updated with new active state
        this.updateMenuItemsActiveState();
      }
    });

    this.dashboardUpdateSubscription = this.dashboardUpdate$.pipe(
      debounceTime(100),
      switchMap(fetchReports => this.dashboard.buildDashboardSectionItems(fetchReports))
    ).subscribe(items => {
      const filteredItems = items.filter((section) => section.label !== "Overview");
      this.dashboardOpts = [...filteredItems];
    });
  }

  async ngOnInit() {
    this.entranceActive = true;
    setTimeout(() => this.entranceActive = false, 2000);
    this.isRentalClient = localStorage.getItem('isRentalClient') === 'true';
    const fullName = localStorage.getItem('customer_name');
    this.userName = this.getFirstName(fullName);
    this.initials = this.parseInitials(fullName);
    this.isAuthModalOpen = this.authModalService.isOpen();
    this.authModalSubscription = this.authModalService.isOpen$.subscribe((isOpen) => {
      this.isAuthModalOpen = isOpen;
    });
    this.isGuestAccount = await this.storage.retrieve('isGuestAccount');
    this.backgroundColor = '#000000';
    document.documentElement.style.setProperty('--header-background', this.backgroundColor);
    this.isEmployerAccount = localStorage.getItem('accountType') === 'employer';
    // Initialize collapsed state from localStorage - ensure it persists
    const savedCollapsedState = localStorage.getItem('navMenuCollapsed');
    this.isMenuCollapsed = savedCollapsedState === 'true';
    this.showMenuText = !this.isMenuCollapsed; // Text should be visible if menu is expanded
    // Apply the collapsed state immediately on init
    if (this.isMenuCollapsed) {
      // If starting collapsed, ensure proper width is set
      const primaryMenuElement = document.getElementById('primary-menu');
      const primaryHeaderElement = document.getElementById('primary-header');
      if (primaryMenuElement) {
        this.togglePrimaryItem(true, primaryMenuElement);
      }
      if (primaryHeaderElement) {
        this.togglePrimaryItem(true, primaryHeaderElement);
      }
    }

    if (!this.menu.showSecondaryMenu) {
      document.documentElement.style.setProperty('--secondary-menu-width', '420px');
      document.documentElement.style.setProperty('--skeleton-menu-width', '60px');
      document.documentElement.style.setProperty('--skeleton-menu-margin-left', '0px');
    } else {
      document.documentElement.style.setProperty('--secondary-menu-width', '260px');
      document.documentElement.style.setProperty('--skeleton-menu-width', '60px');
      document.documentElement.style.setProperty('--skeleton-menu-margin-left', '-4px');
    }
    this.updateMenuData()
    this.listenToPrimaryMenuHoverAction();
    this.getAgentSettings();
    this.fetchAndSaveProxyNumbers();
    this.agentSettingsSubscription = this.events.subscribe('agent:settings:updated', () => {
      this.getAgentSettings();
    });
    this.events.subscribe('goals:updated', () => {
      this.showOnboarding = localStorage.getItem('showOnboarding') === 'true';
      this.setOnboardingGoalCount();
    });
    const aboutThisPageData = localStorage.getItem('aboutThisPageData');
    if (aboutThisPageData) {
      this.loadOnboardingGoals();
    }
  }

  async getAgentSettings() {
    if (!this.auth.isAuthenticated()) {
      return;
    }
    const agentSettings = await this.agentsProvider.getAgentSettings();
    this.agentSettings = agentSettings.reduce((acc, agent) => {
      acc[agent.key] = agent.user_settings.enabled;
      return acc;
    }, {});
  }

  async fetchAndSaveProxyNumbers(): Promise<void> {
    if (!this.auth.isAuthenticated()) {
      return;
    }
    try {
      const proxyNumbers = await this.communication.getProxyNumbers();
      const guestNumber = proxyNumbers?.find(item => item?.number_type === 'guest')?.phone_number;
      const proNumber = proxyNumbers?.find(item => item?.number_type === 'homekeeper')?.phone_number;
      const formatNumber = (number: string): string => {
        if (!number) {return '';}
        return number.replace(/^\+?\d{1,3}(\d{3})(\d{3})(\d{4})$/, '($1) $2-$3');
      };
      localStorage.setItem('cachedGuestNumber', formatNumber(guestNumber));
      localStorage.setItem('cachedProNumber', formatNumber(proNumber));
    } catch (_err) {
      // Silent error - proxy numbers failure is not critical
    }
  }

  ngAfterViewInit() {
    this.loading = true;
    this.currentAddress = parseInt(localStorage.getItem('addressId'), 10);
    this.loading = false;
  }

  expandSidenav(): void {
    const primaryMenuElement = document.getElementById('primary-menu');
    const primaryHeaderElement = document.getElementById('primary-header');
    this.togglePrimaryItem(false, primaryMenuElement);
    this.togglePrimaryItem(false, primaryHeaderElement);
    this.logo = "/assets/img/bowtie-white.svg";
    this.isMenuCollapsed = false;
    // Show text immediately when expanding
    this.showMenuText = true;
    // Clear any pending timeout
    if (this.textDisplayTimeout) {
      clearTimeout(this.textDisplayTimeout);
    }
    // Save state to localStorage
    localStorage.setItem('navMenuCollapsed', 'false');
    this.changeDetector.detectChanges();
    this.menuItems.forEach((item) => {
      const itemElement = document.getElementById(item.target);
      if (itemElement) {
        itemElement.classList.remove('not-display');
      }
    })
  }

  collapseSidenav(): void {
    const primaryMenuElement = document.getElementById('primary-menu');
    const primaryHeaderElement = document.getElementById('primary-header');
    this.togglePrimaryItem(true, primaryMenuElement);
    this.togglePrimaryItem(true, primaryHeaderElement);
    document.documentElement.style.setProperty('--secondary-menu-width', '260px');
    this.logo = "/assets/img/bowtie-white.svg";
    this.isMenuCollapsed = true;
    this.showMenuText = false; // Hide text immediately when collapsing
    // Save state to localStorage
    localStorage.setItem('navMenuCollapsed', 'true');
    this.changeDetector.detectChanges();
    this.menuItems.forEach((item) => {
        const itemElement = document.getElementById(item.target);
        if (itemElement) {
          itemElement.classList.add('not-display');
        }
      })
  }

  listenToPrimaryMenuHoverAction(): void {
    // DISABLED: These hover listeners were causing the text to disappear/reappear
    // when navigating between sections. The menu should only collapse/expand
    // when the user explicitly clicks the toggle button.
    return;

    // Original code commented out:
    // const primaryMenuElement = document.getElementById('primary-menu');
    // primaryMenuElement.addEventListener('mouseenter', () => {
    //   if (this.menu.showSecondaryMenu) {
    //     this.expandSidenav();
    //   }
    // });
    // primaryMenuElement.addEventListener('mouseleave', () => {
    //   if (this.menu.showSecondaryMenu) {
    //     this.collapseSidenav();
    //   }
    // });
    // primaryMenuElement.addEventListener('click', () => {
    //   if (this.menu.showSecondaryMenu) {
    //     this.collapseSidenav();
    //   }
    // });
  }

  togglePrimaryItem(shouldCollapse: boolean, element: HTMLElement): void {
    if (!element) {
      return;
    }
    if (shouldCollapse) {
      element.classList.remove('default-wrapper-width');
      element.classList.add('only-icons-wrapper-width');
    } else {
      element.classList.remove('only-icons-wrapper-width');
      element.classList.add('default-wrapper-width');
    }
  }

  updateSearch() {
    this.filteredAddresses = this.menuAddresses.filter(address => {
      const fieldsCheck = ['address_name', 'address1', 'address2', 'city'];
      return fieldsCheck.some(field => {
        const search = this.form.value.search?.toLowerCase();
        return address[field]?.toLowerCase()?.includes(search);
      })
    });
  }

  changeAddress(address) {
    localStorage.removeItem('taskListId');
    this.currentAddressService.addressId = address.id.toString();
    localStorage.setItem('isAllAddressesSelected', 'false');
    localStorage.setItem('timezone', address.timezone);
    this.currentAddress = address.id;
    this.isAllAddressesSelected = false;
    this.menu.goToRootSection();
  }

  addAddress() {
    if (this.demoBlock.block()) { return; }
    const hasNoAddresses = this.menuAddresses.length > 0;
    const params = {
      hasNoAddresses
    };
    this.navCtrl.navigateForward('add-property', params);
  }

  updateDashboardSection(fetchReports = false) {
    this.dashboardUpdate$.next(fetchReports);
  }

  async updateMenuData() {
    this.isGuestAccount = await this.storage.retrieve('isGuestAccount');
    this.isRentalClient = localStorage.getItem('isRentalClient') === 'true';
    if (!this.auth.isAuthenticated()) {
      // Before the user picks an account type on the auth modal, default
      // to the rental layout (Finance / Revenue / Operations sections) so
      // the empty/un-picked state matches the property-manager experience
      // they'll most likely land in.
      this.isRentalClient = true;
      const menuItems = [
        desktopNavItems[0],  // Overview
        desktopNavItems[1],  // Schedule
        desktopNavItems[2],  // Messages
        financeItem,
        inventoryItem,       // Restocking
        tasksItem,           // Maintenance
        propertiesItem,      // Properties
        desktopNavItems[3],  // Checklists
        marketingItem,
        guidebookItem,
        desktopNavItems[4],  // Contacts
        agentItem,
        moreItem
      ];
      this.setMenuItems(menuItems);
      this.menuAddresses = [];
      this.filteredAddresses = [];
      return;
    }
    this.isAllAddressesSelected = localStorage.getItem('isAllAddressesSelected') === 'true';
    const isEmployerPortal = this.checkIfIsEmployerMockPortal();
    if (isEmployerPortal) {
      this.userName = 'Catrina Ellis';
      this.setMenuItems(employerItemsMock);
      return;
    }
    this.currentAddress = parseInt(localStorage.getItem('addressId'), 10);
    this.accType = await this.me.getAccType();
    const clientInfo = await this.client.getClientInfo();
    this.menuAddresses = this.addressesQueries.addresses();
    // REMOVED: Do not automatically change menu collapse state when navigating
    this.updateSearch();

    this.userRole = localStorage.getItem('user_role');
    const conciergeAddressStatus = localStorage.getItem('isAllAddressesSelected');
    this.isAllAddressesSelected = conciergeAddressStatus === 'true';

    localStorage.setItem('shouldShowAllToDosPage', 'true');
    let menuItems = [...desktopNavItems];
    if (clientInfo.customer_account.account_type !== 'rental') {
      const contactsIndex = menuItems.findIndex(item => item.target === '/contacts');
      if (contactsIndex !== -1) {
        menuItems[contactsIndex] = prosItem;
      }
    }

    const userRole = localStorage.getItem('user_role');
    if (clientInfo.customer_account.account_type === 'rental') {
      menuItems = [
        desktopNavItems[0], // Overview
        desktopNavItems[1], // Schedule
        desktopNavItems[2], // Messages
      ];
      menuItems.push(financeItem);
      menuItems.push(inventoryItem); // Restocking
      menuItems.push(tasksItem); // Maintenance
      menuItems.push(propertiesItem); // Assets
      menuItems.push(desktopNavItems[3]); // Checklists
      menuItems.push(marketingItem);
      menuItems.push(complianceItem);
      menuItems.push(eSignItem);
      menuItems.push(guidebookItem);
      menuItems.push(desktopNavItems[4]); // Pros
      menuItems.push(agentItem);
      menuItems.push(moreItem);
    } else {
      menuItems.push(agentItem);
      menuItems.push(moreItem);
    }

    if (clientInfo.customer_account.account_type === 'employer') {
      menuItems = employerItems;
    }

    if (clientInfo.customer_account.account_name) {
      this.accountName = clientInfo.customer_account.account_name;
    }

    if (!this.sameMenuContent(menuItems)) {
      this.setMenuItems(menuItems);
    }

    this.integrationOptions = integrationSectionItems;
    this.automationOptions = automationsSectionItems;
    await this.updateDashboardSection();
    const fullName = clientInfo.current_user.name;
    this.userName = this.getFirstName(fullName);
    this.initials = this.parseInitials(fullName);
    if (userRole !== 'owner' && this.checkIfIsEmployerPortal()) {
      this.menuItems.pop();
      this.partitionMenuItems();
    }

    // REMOVED: Do not automatically change menu collapse state based on secondary menu
    // The user should be in control of the collapsed state

    if (!this.menu.showSecondaryMenu) {
      document.documentElement.style.setProperty('--secondary-menu-width', '420px');
      document.documentElement.style.setProperty('--skeleton-menu-width', '60px');
      document.documentElement.style.setProperty('--skeleton-menu-margin-left', '0px');
      this.logo = "/assets/img/bowtie-white.svg";
      this.expandSidenav()
    } else {
      document.documentElement.style.setProperty('--secondary-menu-width', '260px');
      document.documentElement.style.setProperty('--skeleton-menu-width', '60px');
      document.documentElement.style.setProperty('--skeleton-menu-margin-left', '-4px');
      this.logo = "/assets/img/bowtie-white.svg";
      this.collapseSidenav()
    }
  }

  checkIfIsEmployerMockPortal() {
    const urls = [
      '/employer-campaign',
      '/employer-compliance',
      '/employer-employees',
      '/employer-get-started',
      '/employer-integrations'
    ];
    return urls.includes(this.router.url);
  }

  checkIfIsEmployerPortal() {
    const urls = [
      '/employer-campaign/employer-campaign',
      '/employer-compliance/employer-compliance',
      '/employer-dashboard/employer-dashboard',
      '/employer-get-started/employer-get-started',
      '/employer-integrations/employer-integrations',
      '/employer-settings',
      '/employer-admins/employer-admins',
      '/employer-add-new-admin/employer-add-new-admin',
      '/employer-edit-admin/employer-edit-admin'
    ];
    return urls.includes(this.router.url);
  }

  get isChatActive(): boolean {
    return this.router.url === '/chat';
  }

  isCurrentItem(item: any, effect?: string): boolean {
    if (item.target === '/overview' || item.target === '/properties') {
      return this.router.url === item.target || this.router.url.startsWith(`${item.target}?`);
    }
    return this.router.url === item.target ||
           (item.target !== '/employer-settings' && this.router.url.startsWith(item.target));
  }

  enrichMenuItemsWithActiveState(items: any[]): any[] {
    if (!items) {
      return items;
    }
    return items.map(item => ({
      ...item,
      _isCurrentItem: this.isCurrentItem(item),
      _hasBackgroundEffect: this.isCurrentItem(item, 'backgroundEffect')
    }));
  }

  // Targets rendered as standalone root-level items (Agents sits under Chat).
  // Finance and Marketing are extracted into their own expandable sections;
  // Properties is folded into the Operations section as a plain link.
  private static readonly ROOT_TARGETS = new Set(['/assets', '/agent', '/more']);

  private setMenuItems(items: any[]): void {
    this.rawMenuItems = items;
    this.menuItems = this.enrichMenuItemsWithActiveState(this.filterForRentalModes(items));
    this.partitionMenuItems();
    this.updateSectionActiveState();
  }

  /** Drops long-term-only root items (eSignature) when the toggle is off. */
  private filterForRentalModes(items: any[]): any[] {
    if (this.longTermRentals) { return items; }
    return items.filter(item => !DesktopNavComponent.LONG_TERM_TARGETS.includes(item?.target));
  }

  /**
   * Re-applies the Account Settings rental-mode gate to the Finance / Revenue
   * sub-lists and the root menu. Safe to call before the menu has loaded — the
   * sub-lists are static, and the root list is skipped until updateMenuData runs.
   */
  private applyRentalModes(): void {
    this.financeItems = financeSectionItems
      .filter(item => item.tab !== 'overview')
      .filter(item => this.longTermRentals || !DesktopNavComponent.LONG_TERM_FINANCE_TABS.includes(item.tab))
      .map(item => ({ ...item, _isCurrentItem: false }));
    this.marketingItems = marketingSectionItems
      .filter(item => this.longTermRentals || !DesktopNavComponent.LONG_TERM_MARKETING_TABS.includes(item.tab))
      .map(item => ({ ...item, _isCurrentItem: false }));
    if (this.rawMenuItems) {
      this.setMenuItems(this.rawMenuItems);
    }
  }

  private partitionMenuItems(): void {
    const operations: any[] = [];
    const root: any[] = [];
    let scheduleItem: any = null;
    let messagesItem: any = null;
    this.hasFinanceSection = false;
    this.hasMarketingSection = false;
    if (this.menuItems) {
      for (const item of this.menuItems) {
        if (item.target === '/overview' || item.target === '/properties') {
          // Overview and Properties are the standalone root-level items in the
          // template, not menu entries.
          continue;
        }
        if (item.target === '/schedule') {
          // Promoted to a standalone root-level item directly under Overview.
          scheduleItem = item;
          continue;
        }
        if (item.target === '/messages') {
          // Pulled out so Messages can be injected at the top of Operations.
          messagesItem = item;
          continue;
        }
        if (item.target === '/upgrades') {
          // Upgrades now lives in the Revenue (marketing) section, sourced
          // from marketingSectionItems — drop it from Operations.
          continue;
        }
        if (item.target === '/finance') {
          this.hasFinanceSection = true;
        } else if (item.target === '/revenue') {
          this.hasMarketingSection = true;
        } else if (DesktopNavComponent.ROOT_TARGETS.has(item.target)) {
          root.push(item);
        } else {
          // Everything else (Restocking, Maintenance, Checklists, Compliance,
          // Guidebook, Contacts) lives in Operations.
          operations.push(item);
        }
      }
    }
    // Operations sub-items: Messages, then Assets / Access, then the rest
    // (compliance group expanded below). Upgrades moved to Revenue.
    operations.unshift(
      ...(messagesItem ? [messagesItem] : []),
      { ...operationsAssetsItem },
      { ...operationsAccessItem },
    );
    // Compliance group: keep /compliance, then inject Noise Monitoring and
    // Insurance immediately after it.
    const complianceIndex = operations.findIndex(item => item.target === '/compliance');
    if (complianceIndex >= 0) {
      operations.splice(complianceIndex + 1, 0,
        { ...noiseMonitoringItem },
        { ...insuranceItem },
      );
    }
    // Schedule rendered separately as a top-level button above Revenue.
    this.scheduleNavItem = scheduleItem;
    // Agents: pull from root and append at the bottom of Operations.
    const agentIndex = root.findIndex(item => item.target === '/agent');
    const agentNavEntry = agentIndex >= 0 ? root.splice(agentIndex, 1)[0] : null;
    if (agentNavEntry) {operations.push(agentNavEntry);}
    this.agentNavItem = null;
    this.operationsItems = operations;
    this.rootItems = root;
  }

  private updateSectionActiveState(): void {
    // Section headers never highlight — they only expand/collapse. The active
    // state lives entirely on the sub-items.
    this.updateSubItemsActiveState(this.financeItems, '/finance', 'bills');
    this.updateSubItemsActiveState(this.marketingItems, '/revenue', 'upsells');
    // Operations sub-items are a mix of menuItems-derived rows (Schedule,
    // Messages, etc.) AND statically-injected rows (Assets, Access, Upgrades,
    // Noise Monitoring, Insurance). The injected ones never go through
    // enrichMenuItemsWithActiveState, so refresh `_hasBackgroundEffect` on
    // every entry here.
    for (const item of this.operationsItems ?? []) {
      item._hasBackgroundEffect = this.isCurrentItem(item);
    }
    // Standalone root-level items promoted out of Finance / Operations.
    const url = this.router.url;
    this.isOverviewActive = url === '/overview' || url.startsWith('/overview?');
    this.isPropertiesActive = url === '/properties' || url.startsWith('/properties?');
    this.isScheduleActive = url === '/schedule' || url.startsWith('/schedule?');
  }

  private updateSubItemsActiveState(items: any[], basePath: string, defaultTab: string): void {
    const path = this.router.url.split('?')[0];
    const onPage = path === basePath;
    const tabMatch = this.router.url.match(/[?&]tab=([^&]+)/);
    const currentTab = onPage ? (tabMatch ? tabMatch[1] : defaultTab) : null;
    for (const item of items) {
      // Overview sub-items navigate to a standalone route; the rest match a ?tab= value.
      item._isCurrentItem = item.isOverview
        ? path === item.route
        : item.tab === currentTab;
    }
  }

  updateMenuItemsActiveState(): void {
    if (this.menuItems) {
      // Update active state in place to avoid re-rendering
      this.menuItems.forEach(item => {
        const isCurrentItem = this.isCurrentItem(item);
        // Only update if the value actually changed
        if (item._hasBackgroundEffect !== isCurrentItem) {
          item._hasBackgroundEffect = isCurrentItem;
          item._isCurrentItem = isCurrentItem;
        }
      });
      this.updateSectionActiveState();
      // Use markForCheck instead of detectChanges for more efficient rendering
      this.changeDetector.markForCheck();
    }
  }

  // Section headers only expand/collapse — they never navigate and never
  // highlight. Each section's "Overview" sub-item handles navigation to its
  // landing page. Only one section can be expanded at a time (accordion).
  openOperationsSection(): void {
    this.operationsMenuExpanded = !this.operationsMenuExpanded;
    if (this.operationsMenuExpanded) {
      this.financeMenuExpanded = false;
      this.marketingMenuExpanded = false;
    }
  }

  openFinanceSection(): void {
    this.financeMenuExpanded = !this.financeMenuExpanded;
    if (this.financeMenuExpanded) {
      this.marketingMenuExpanded = false;
      this.operationsMenuExpanded = false;
    }
  }

  openMarketingSection(): void {
    this.marketingMenuExpanded = !this.marketingMenuExpanded;
    if (this.marketingMenuExpanded) {
      this.financeMenuExpanded = false;
      this.operationsMenuExpanded = false;
    }
  }

  // Sub-items switch the page tab via a query-param navigation on the same
  // route, so the OnPush Finance/Marketing pages reliably re-render.
  goToTab(basePath: string, tab: string): void {
    this.router.navigate([basePath], { queryParams: { tab } });
    setTimeout(() => this.updateMenuItemsActiveState(), 100);
  }

  onMouseLeave() {
    // Re-enable tooltips when mouse leaves the button
    this.tooltipDisabled = false;
  }

  async goToLink(url) {
    // Prevent tooltips from showing after click
    this.tooltipDisabled = true;

    // Hide all tooltips when clicking a nav item
    if (this.tooltips) {
      this.tooltips.forEach(tooltip => {
        tooltip.hide();
      });
    }

    this.storage.delete('onboardingFlow');
    this.currentItem = url;
    if (url === '/help') {
      this.goToHelp()
      return
    }
    // Update menu items active state immediately after navigation
    setTimeout(() => {
      this.updateMenuItemsActiveState();
    }, 100);
    localStorage.setItem('loggedIssuesBackPage', '');
    if (url.startsWith('/integration/')) {
      localStorage.setItem('integrationsBackPage', '')
    }
    const isProsPage = url === '/contacts' || url === '/my-pros';
    if (isProsPage) {
      localStorage.setItem('myProsBackPage', '')
    }
    if (url !== '/concierge' && url !== '/messages' && url !== '/maintenance' && url !== '/bills' && !isProsPage) {
      localStorage.setItem('isAllAddressesSelected', 'false');
    } else if (url === '/concierge' || url === '/messages' || url === '/maintenance' || url === '/bills') {
      localStorage.setItem('isAllAddressesSelected', 'true');
      this.isAllAddressesSelected = true;
      this.updateMenuData();
    }
    if (isProsPage && this.menuAddresses.length <= 1) {
      localStorage.setItem('isAllAddressesSelected', 'false');
    } else {
      localStorage.setItem('isAllAddressesSelected', 'true');
    }
    if (url === '/restocking') {
      this.updateMenuData();
    }
    if (url === '/schedule' && this.menuAddresses.length > 1) {
      localStorage.setItem('isAllAddressesSelected', 'true');
      this.isAllAddressesSelected = true;
    }
    if (url === propertyDashboardPath()) {
      const isAllPropertiesSelected = localStorage.getItem('isAllPropertiesSelected');
      if (isAllPropertiesSelected !== 'true') {
        const propertyId = localStorage.getItem('addressId');
        if (propertyId) {
          this.navCtrl.navigateForward(url, { queryParams: { propertyId } });
          return;
        }
      }
    }
    this.navCtrl.navigateForward(url);
  }

  goToHelp() {
    const isEmployerPortal = this.checkIfIsEmployerPortal();
    const url = isEmployerPortal ? 'https://help.tidy.com/employers' : 'https://www.tidy.com/docs/pm/getting-started';
    this.util.openUrl(url);
  }

  toggleNavCollapse() {
    this.isMenuCollapsed = !this.isMenuCollapsed;

    // Clear any pending timeout
    if (this.textDisplayTimeout) {
      clearTimeout(this.textDisplayTimeout);
    }

    // Show/hide text immediately based on collapsed state
    this.showMenuText = !this.isMenuCollapsed;

    // Store the collapsed state in localStorage to persist across navigation
    localStorage.setItem('navMenuCollapsed', this.isMenuCollapsed.toString());
    // Force change detection to update view immediately
    this.changeDetector.detectChanges();
  }

  goToSettings() {
    this.navCtrl.navigateForward('employer-settings');
  }

  async moreOptsAction(option) {
    const external = option.target?.includes('https://')
    if (external) {
      return this.util.openUrl(option.target);
    }

    if (option.target === 'logout') {
      return this.events.publish('logout');
    }
    await this.navCtrl.navigateForward(option.target);
  }

  dashboardOptsAction(option) {
    this.navCtrl.navigateForward(option.target);
  }

  addReport() {
    this.navCtrl.navigateForward('reports/add-report');
  }

  selectAllAddresses() {
    localStorage.setItem('isAllAddressesSelected', 'true');
    this.isAllAddressesSelected = true;
    this.menu.goToRootSection();
  }

  sameMenuContent(newItems): boolean {
    if (this.menuItems) {
      return newItems
        .every((item, index) => Object.keys(item)
            .every(itemKey => item[itemKey] === this.menuItems[index][itemKey]));
    }
    return false;
  }

  showAllAddressesButton() {
    if (this.router.url === '/schedule' && this.accType !== 'rental' && this.menuAddresses.length === 1) {
      this.isAllAddressesSelected = false;
      localStorage.setItem('isAllAddressesSelected', 'false');
      return false;
    } else {
      return (this.router.url === '/contacts' ||
      this.router.url === '/my-pros' ||
      this.router.url === '/schedule' ||
      this.router.url === '/concierge' ||
      this.router.url === '/messages' ||
      this.router.url === '/maintenance' ||
      this.router.url.includes('log-issue') ||
      this.router.url.includes('get-help') ||
      this.router.url.includes('bill') ||
      this.router.url.includes('contact-concierge') &&
      this.filteredAddresses.length === this.menuAddresses.length);
    }

  }

  ngOnDestroy() {
    if (this.addAddressSubs) {
      this.addAddressSubs.unsubscribe();
    }
    if (this.agentSettingsSubscription) {
      this.agentSettingsSubscription.unsubscribe();
    }
    if (this.authModalSubscription) {
      this.authModalSubscription.unsubscribe();
    }
    if (this.dashboardUpdateSubscription) {
      this.dashboardUpdateSubscription.unsubscribe();
    }
  }

  parseInitials(fullName: string): string {
    if (!fullName) {
      return '';
    }
    return fullName
      .match(/(\b\S)?/g)
      .join('')
      .match(/(^\S|\S$)?/g)
      .join('')
      .toUpperCase();
  }

  getFirstName(fullName: string): string {
    if (!fullName) {
      return '';
    }
    return fullName.split(' ')[0];
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    if (
      this.showUserDropdown &&
      this.userIconRef?.nativeElement &&
      this.userDropdownRef?.nativeElement &&
      !this.userIconRef.nativeElement.contains(event.target) &&
      !this.userDropdownRef.nativeElement.contains(event.target)
    ) {
      this.showUserDropdown = false;
    }
  }

  toggleUserDropdown(event: Event) {
    event.stopPropagation();
    this.showUserDropdown = !this.showUserDropdown;
  }

  toggleAgentsMenu(event: Event) {
    event.stopPropagation();
    this.agentsMenuExpanded = !this.agentsMenuExpanded;
  }

  toggleHelpMenu(event: Event) {
    event.stopPropagation();
    this.helpMenuExpanded = !this.helpMenuExpanded;
  }

  goToContactInfo() {
    this.showUserDropdown = false;
    if (this.demoBlock.block()) { return; }
    this.openRightSidePanel({}, ContactInfoPage);
  }

  goToDemo() {
    this.showUserDropdown = false;
    this.openRightSidePanel({}, DemoPage);
  }

  goToSubscriptionPage() {
    this.showUserDropdown = false;
    if (this.demoBlock.block()) { return; }
    this.openRightSidePanel({}, SubscriptionsPage);
  }

  logout(): void {
    this.showUserDropdown = false;
    const themeMode = localStorage.getItem('tidy_theme_mode');
    localStorage.clear();
    if (themeMode) {
      localStorage.setItem('tidy_theme_mode', themeMode);
    }
    this.events.publish('logout');
  }

  // True only while logged into the sales demo account. Read live from
  // localStorage (not cached) so the "Already have an account?" prompt shows
  // only during a demo session and disappears the moment it ends — signing in,
  // creating an account, or logging out all clear this flag.
  get isDemoAccount(): boolean {
    return localStorage.getItem('isDemoAccount') === 'true';
  }

  goToLogin(): void {
    this.authModalService.openAuthModal('auth');
  }

  // Demo account: open the auth modal straight to a sign-in-only view (no sign
  // up). Signing in there clears the demo session and logs into the real
  // account via the modal's existing onSignIn flow — no extra steps.
  goToSignInFromDemo(): void {
    this.authModalService.openAuthModal('auth', 'signin', '', true);
  }

  goToCreateAccount(): void {
    if (this.isGuestAccount) {
      this.authModalService.openAuthModal('convert');
    } else {
      this.navCtrl.navigateForward('create-account');
    }
  }

  async onTypeSelected(): Promise<void> {
    this.isGuestAccount = true;
    this.fadeInSignIn = true;
    this.isRentalClient = localStorage.getItem('isRentalClient') === 'true';
    const guestType = localStorage.getItem('guest_view_type');
    let menuItems = [...desktopNavItems];
    if (guestType !== 'rental') {
      const contactsIndex = menuItems.findIndex(item => item.target === '/contacts');
      if (contactsIndex !== -1) {
        menuItems[contactsIndex] = prosItem;
      }
    }
    if (guestType === 'rental') {
      menuItems = [
        desktopNavItems[0],
        desktopNavItems[1],
        desktopNavItems[2],
      ];
      menuItems.push(financeItem);
      menuItems.push(inventoryItem);
      menuItems.push(tasksItem);
      menuItems.push(propertiesItem);
      menuItems.push(desktopNavItems[3]);
      menuItems.push(marketingItem);
      menuItems.push(guidebookItem);
      menuItems.push(desktopNavItems[4]);
      menuItems.push(agentItem);
      menuItems.push(moreItem);
    } else {
      menuItems.push(agentItem);
      menuItems.push(moreItem);
    }
    this.setMenuItems(menuItems);
    this.changeDetector.detectChanges();
  }

  async onAuthComplete(): Promise<void> {
    const wasGuestAccount = this.isGuestAccount;
    this.isGuestAccount = await this.storage.retrieve('isGuestAccount');
    if (this.isGuestAccount && !wasGuestAccount) {
      this.fadeInSignIn = true;
    }
    if (this.auth.isAuthenticated()) {
      try {
        const clientInfo = await this.client.getClientInfo();
        const fullName = clientInfo.current_user.name;
        this.userName = this.getFirstName(fullName);
        this.initials = this.parseInitials(fullName);
        this.changeDetector.markForCheck();
      } catch (err) {
        // Silently fail - will use default/guest values
      }
      this.getAgentSettings();
      this.notificationsQueries.refetchBadge();
    }
    this.updateMenuData();
  }

  async openRightSidePanel(params, component, data = {}) {
    await this.storage.save('shouldUpdateItems', false);
    const dialogParams = await this.storage.retrieve('dialog-params');
    params = {
      ...dialogParams,
      ...params,
    };
    await this.storage.save('dialog-params', params);
    await this.storage.save('dialog-right-side-open', true);
    this.rightSidePanelService.openRightSidePanel(component, data);
  }

  get notificationCount(): number {
    if (!this.auth.isAuthenticated()) {
      return 0;
    }
    return this.notificationsQueries.notificationCount();
  }

  navigateToConcierge() {
    this.headerProvider.showConciergePage = true;
    this.headerProvider.showNotificationCenter = false;
    this.showUserDropdown = false;
    this.openRightSidePanel({}, ConciergePage);
  }

  navigateToNotificationCenter() {
    this.headerProvider.showConciergePage = false;
    this.headerProvider.showNotificationCenter = true;
    this.showUserDropdown = false;
    this.openRightSidePanel({}, NotificationCenterPage, {dropDownMenu: notificationCenterDropDownMenu});
  }

  openSearch() {
    this.events.publish('global-search:open');
  }

  async getSubscriptionInfo() {
    try {
      const [subscriptions, hasNegativeBalance, meData] = await Promise.all([
        this.me.getSubscriptions(),
        this.me.getHasNegativeBalance(),
        this.me.load(true)
      ]);
      this.hasNegativeBalance = hasNegativeBalance;
      this.isAccountSuspended = meData.suspended_at ? true : false;
      if (subscriptions.length > 1) {
        subscriptions.map((subscription) => {
          if (subscription.is_activated_in_next_cycle) {
            this.subscription = subscription;
          } else {
            this.subscription = subscription;
          }
        });
      } else {
        this.subscription = subscriptions[0];
      }
    } catch (_error) {
      // Silent error - subscription info failure is not critical
    }
  }

  async loadOnboardingGoals() {
    this.showOnboarding = true;
    try {
      this.setOnboardingGoalCount();
      this.isInitialLoad = true;
      this.onboardingProvider.getShowOnboardingInHeader().subscribe(async (show) => {
        if (!this.isInitialLoad) {
          this.oldAutomatedPercentage = this.automatedPercentage;
          await this.setOnboardingGoalCount();
          this.showOnboarding = show;
          if (this.showOnboarding && this.automatedPercentage > this.oldAutomatedPercentage) {
            this.throwConfetti();
            this.showGlowAnimation = true;
          }
        }
        this.isInitialLoad = false;
        setTimeout(() => {
          this.showGlowAnimation = false;
        }, 1000);
      });
    } catch (_error) {
      // Silent error - onboarding goals failure is not critical
    }
  }

  async setOnboardingGoalCount() {
    let goals = await this.storage.retrieve('onboardingGoals');
    if (!goals) {
      await this.onboardingProvider.getGoalsFromServer();
      goals = await this.storage.retrieve('onboardingGoals');
    }
    if (goals) {
      this.automatedPercentage = this.calculateAutomatedPercentage(goals);
      this.completedGoals = this.getCompletedGoalCount(goals);
      this.totalGoals = goals.length;
    }
  }

  calculateAutomatedPercentage(goals: any[]): number {
    let totalSteps = 0;
    let completedSteps = 0;
    goals.forEach((goal) => {
      if (goal.user_goal_steps && goal.user_goal_steps.length > 0) {
        totalSteps += goal.user_goal_steps.length;
        completedSteps += goal.user_goal_steps.filter((step) => step.state === 'done').length;
      }
    });
    if (totalSteps === 0) {
      return 0;
    }
    return Math.round((completedSteps / totalSteps) * 100);
  }

  getCompletedGoalCount(goals) {
    return goals.filter((goal) => goal.state === 'done').length;
  }

  async throwConfetti() {
    const canvas = this.renderer.createElement('canvas');
    canvas.style.position = 'fixed';
    canvas.style.top = '0';
    canvas.style.left = '0';
    canvas.style.width = '100%';
    canvas.style.height = '100%';
    canvas.style.pointerEvents = 'none';
    canvas.style.zIndex = '9999';
    this.renderer.appendChild(document.body, canvas);
    const confettiAnimation = confetti.create(canvas, { resize: true });
    try {
      await confettiAnimation(spookyConfetti({
        particleCount: 150,
        spread: 180,
        startVelocity: 45,
        decay: 0.9,
        gravity: 1,
        origin: { x: 0.5, y: 0.5 },
      }));
    } catch (_error) {
      // Silent error - confetti animation failure is not critical
    }
    this.renderer.removeChild(document.body, canvas);
  }

  goToSubscriptionPageFromIndicator() {
    if (this.demoBlock.block()) { return; }
    if (this.hasNegativeBalance) {
      this.openRightSidePanel({}, ChangeSubscriptionPage);
    } else {
      this.openRightSidePanel({}, SubscriptionsPage);
    }
  }

  openLearnMore() {
    this.util.openUrl('https://www.tidy.com/rentals');
  }

  openPricing() {
    this.util.openUrl('https://www.tidy.com/pricing');
  }

  openTerms() {
    this.util.openUrl('https://www.tidy.com/legal/property-managers-customer');
  }

  openWhatsNew() {
    this.util.openUrl('https://www.tidy.com/blog?tag=changelog');
  }

  openDocumentation() {
    this.util.openUrl('https://www.tidy.com/docs/pm/getting-started');
  }

  openContactSupport() {
    this.util.openUrl('https://www.tidy.com/contact');
  }

  startLongPress() {
    this.longPressTimeout = setTimeout(() => {
      this.showAppVersion = true;
      this.changeDetector.detectChanges();
    }, 1000);
  }

  endLongPress() {
    if (this.longPressTimeout) {
      clearTimeout(this.longPressTimeout);
      this.longPressTimeout = null;
    }
  }

}
